import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViewType } from '../../types';
import { Button } from '@utex/ui-kit';
import { GroupPanel } from '@utex/ui-kit/desktop';
import { getExtraDimHeaderButton, getPrimaryDimHeaderButton } from '../HeaderButtons/buttonsView';
import { headerButtonPadding } from './styles';

interface Props {
  view: ViewType;
  onLogin: () => void;
  onRegistration: () => void;
}

export const Authentication = (props: Props) => {
  const { t } = useTranslation('header');
  const { onLogin, onRegistration, view } = props;
  return (
    <GroupPanel>
      <Button
        view={getExtraDimHeaderButton(view)}
        isBlured={view !== 'default'}
        css={headerButtonPadding}
        onClick={() => {
          onLogin();
        }}
        data-testid="header-signin-btn"
        data-gtm="header-signin-btn"
      >
        {t('Login')}
      </Button>
      <Button
        view={getPrimaryDimHeaderButton(view)}
        isBlured={view !== 'default'}
        css={headerButtonPadding}
        onClick={() => {
          onRegistration();
        }}
        data-testid="header-signup-btn"
        data-gtm="header-signup-btn"
      >
        {t('Registration')}
      </Button>
    </GroupPanel>
  );
};
